// extracted by mini-css-extract-plugin
module.exports = {"contentHolder":"bankIdStyles_contentHolder__cwlff"};